import React from 'react'
import AppBreadcrumbs from "./AppBreadcrumbs";
import Grid from "@material-ui/core/Grid";
import ItemDashBoard from "./ItemDashBoard";
import CuentaSelected from "../helpers/CuentaSelected";
import ChipUserAccount from "./ChipUserAccount";
import {withRouter} from 'react-router';
import PostAddIcon from '@material-ui/icons/PostAdd';
import BarChartIcon from '@material-ui/icons/BarChart';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PaymentIcon from '@material-ui/icons/Payment';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import {getFiltersByAccount} from "../helpers/Helpers";
import WarningIcon from '@material-ui/icons/Warning';
import MaterialIcon from 'material-icons-react';

class DashBoard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            account: {},
        };
    }

    componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });
    }

    render() {

        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>
                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }
                    ]}
                    actual='Menú'
                />

                <h2>
                    <ChipUserAccount/>
                    Escoja una opción
                </h2>

                <Grid container style={{paddingLeft: '50px', paddingRight: '50px'}}>
                    <ItemDashBoard
                        title='PQR'
                        description='Crear y consultar el estado de sus PQRS'
                        path='/list-pqrs'
                        icon={<PostAddIcon color="primary" style={{fontSize: 80}}/>}
                    />
                    <ItemDashBoard
                        title='Consumos'
                        description='Consultar sus últimos consumos'
                        path='/consumptions'
                        icon={<BarChartIcon color="primary" style={{fontSize: 80}}/>}
                    />
                    <ItemDashBoard
                        title='Facturas'
                        description='Consultar sus últimas facturas'
                        path='/invoices'
                        icon={<ReceiptIcon color="primary" style={{fontSize: 80}}/>}
                    />
                    <ItemDashBoard
                        title='Pagos'
                        description='Realizar pago en línea de su factura y consultar sus últimos pagos'
                        path='/payments'
                        icon={<PaymentIcon color="primary" style={{fontSize: 80}}/>}
                    />

                    {
                        getFiltersByAccount() ?
                            <ItemDashBoard
                                title='Autogeneradores'
                                description='Consultar autogeneradores'
                                path='/autogenerator'
                                icon={<WbSunnyIcon color="primary" style={{fontSize: 80}}/>}
                            />
                            : null
                    }

                    <ItemDashBoard
                        title='Actas'
                        description='Consultar actas'
                        path='/proceedings'
                        icon={<MaterialIcon icon="description" color='#0098DB' size={80}/>}
                    />

                    <ItemDashBoard
                        title='Suspensiones'
                        description='Consultar suspensiones'
                        path='/suspensions'
                        icon={<WarningIcon color="primary" style={{fontSize: 80}}/>}
                    />
                </Grid>

            </div>
        );
    }
}

export default withRouter(DashBoard)